import axios from './axios-ekmtc'

const instance = axios.createInstance()
instance.defaults.baseURL = process.env.VUE_APP_SETTLE_URL

export default instance
